define("shared/components/shared/modal/banner", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if (has-block)}}
    {{yield}}
  {{else}}
    <div class="tEA--modalBanner">
      <span class="tEA--modalBanner__title">{{@title}}</span>
      {{#if @link}}
        <a class="tEA--modalBanner__link" href={{@link}} rel="noopener noreferrer" target="_blank">
          {{t "shared_phrases.learn_more"}}
        </a>
      {{/if}}
    </div>
  {{/if}}
  */
  {
    "id": "Cdv0KfqH",
    "block": "[[[41,[48,[30,3]],[[[1,\"  \"],[18,3,null],[1,\"\\n\"]],[]],[[[1,\"  \"],[10,0],[14,0,\"tEA--modalBanner\"],[12],[1,\"\\n    \"],[10,1],[14,0,\"tEA--modalBanner__title\"],[12],[1,[30,1]],[13],[1,\"\\n\"],[41,[30,2],[[[1,\"      \"],[10,3],[14,0,\"tEA--modalBanner__link\"],[15,6,[30,2]],[14,\"rel\",\"noopener noreferrer\"],[14,\"target\",\"_blank\"],[12],[1,\"\\n        \"],[1,[28,[35,3],[\"shared_phrases.learn_more\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"]],[]]]],[\"@title\",\"@link\",\"&default\"],false,[\"if\",\"has-block\",\"yield\",\"t\"]]",
    "moduleName": "shared/components/shared/modal/banner.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});